module.exports = __webpack_public_path__ + "pattern_square.0bc5501a.svg";


//////////////////
// WEBPACK FOOTER
// ./demo/src/img/pattern_square.svg
// module id = FUqP
// module chunks = 0